import { useMarketplace } from "../hooks/useMarketplace";

export function PacketsPage() {
  const { packets } = useMarketplace();
  return <section className="rounded-2xl border border-slate-200 bg-white p-8 shadow-sm "><h1 className="text-4xl font-black">Transaction packets</h1><div className="mt-6 grid gap-4">{packets.map(packet => <article className="rounded-2xl bg-slate-50 p-5" key={packet.id}><strong>{packet.orderId}</strong><p className="text-slate-600">{packet.status.replace("_", " ")} · {packet.documents.length} documents</p></article>)}</div></section>;
}
